<script>
  export let size = 16;
</script>

<svg
  width="{size}"
  height="{size}"
  fill="currentColor"
  aria-hidden="true"
  {...$$restProps}
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 32 32"
  ><defs
    ><style>
      .cls-1 {
        fill: none;
      }
    </style></defs
  ><title>link</title><path
    d="M29.25,6.76a6,6,0,0,0-8.5,0l1.42,1.42a4,4,0,1,1,5.67,5.67l-8,8a4,4,0,1,1-5.67-5.66l1.41-1.42-1.41-1.42-1.42,1.42a6,6,0,0,0,0,8.5A6,6,0,0,0,17,25a6,6,0,0,0,4.27-1.76l8-8A6,6,0,0,0,29.25,6.76Z"
  ></path><path
    d="M4.19,24.82a4,4,0,0,1,0-5.67l8-8a4,4,0,0,1,5.67,0A3.94,3.94,0,0,1,19,14a4,4,0,0,1-1.17,2.85L15.71,19l1.42,1.42,2.12-2.12a6,6,0,0,0-8.51-8.51l-8,8a6,6,0,0,0,0,8.51A6,6,0,0,0,7,28a6.07,6.07,0,0,0,4.28-1.76L9.86,24.82A4,4,0,0,1,4.19,24.82Z"
  ></path><rect
    id="_Transparent_Rectangle_"
    data-name="&lt;Transparent Rectangle&gt;"
    class="cls-1"
    width="32"
    height="32"></rect></svg
>
